import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

// Vínculo sensor → parâmetro (1:1 ativo). Invalida ["sensors"] (árvore +
// detalhe), ["lines"] e ["parameters"] (sidebar da máquina) — ver tabela viva no CLAUDE.md.
function invalidate(qc: ReturnType<typeof useQueryClient>) {
  void qc.invalidateQueries({ queryKey: ["sensors"] });
  void qc.invalidateQueries({ queryKey: ["lines"] });
  void qc.invalidateQueries({ queryKey: ["parameters"] });
}

export function useLinkSensorToParameter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ parameterId, sensorId }: { parameterId: string; sensorId: string }) =>
      api.post(`/api/v1/parameters/${parameterId}/sensor-link`, { sensorId }),
    onSuccess: () => invalidate(qc),
    meta: { skipErrorToast: true },
  });
}

export function useUnlinkSensorLink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (linkId: string) => api.delete(`/api/v1/sensor-links/${linkId}`),
    onSuccess: () => invalidate(qc),
    meta: { skipErrorToast: true },
  });
}
